import { PaginatedProjects } from "@custom-types/project-types";
import { fetchProjects } from "@store/projects/projects-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { useEffect } from "react";

type Props = Pick<
  PaginatedProjects,
  "companyId" | "projectArchivingState" | "sortBy" | "search" | "groupId"
>;

/** Custom hook that fetches projects based on changes in the search, groupId or sortBy queries */
export function useFetchProjectsOnQueryChange({
  companyId,
  projectArchivingState,
  sortBy,
  search,
  groupId,
}: Props): void {
  const dispatch = useAppDispatch();

  // Fetches projects whenever the companyId, projectState, groupId, search query, or sortBy criteria change
  // Resets the table pagination and initial fetching items before fetching new projects
  useEffect(() => {
    dispatch(setInitialFetchingItems([]));

    void dispatch(
      fetchProjects({
        companyId,
        projectArchivingState,
        groupId,
        search,
        sortBy,
      })
    );
  }, [companyId, dispatch, groupId, projectArchivingState, search, sortBy]);
}
